import { createReducer, on } from '@ngrx/store';
import {
	createEmptyOwnedStateResource,
	createOwnedStateResource,
	OwnedStateResource,
} from '@schir-int-client/ngrx-helpers';
import { loadVerfahrenSingleSuccessAction } from '@schir-int-client/verfahren-shared';
import {
	loadChangeEntriesAction,
	loadChangeEntriesSuccessAction,
	refreshStateAction,
} from '../../../register-change/src/lib/register-change.actions';
import { ChangeEntryListLinkRel, ChangeEntryListResource } from '@schir-int-client/register-change';

export interface RegisterBlattState {
	changeEntries: OwnedStateResource<ChangeEntryListResource>;
}

export const initialState: RegisterBlattState = { changeEntries: createEmptyOwnedStateResource() };

export const registerBlattReducer = createReducer(
	initialState,
	on(loadChangeEntriesAction, (state: RegisterBlattState, { verfahren }): RegisterBlattState => ({
		...state,
		changeEntries: createEmptyOwnedStateResource(verfahren._links.self.href, true),
	})),
	on(loadChangeEntriesSuccessAction, (state: RegisterBlattState, { changeEntries }): RegisterBlattState => ({
		...state,
		changeEntries: createOwnedStateResource(
			changeEntries._links[ChangeEntryListLinkRel.VERFAHREN].href,
			changeEntries
		),
	})),
	on(loadVerfahrenSingleSuccessAction, (state: RegisterBlattState): RegisterBlattState => ({
		...state,
		changeEntries: { ...state.changeEntries, reload: true },
	})),
	on(refreshStateAction, (state: RegisterBlattState): RegisterBlattState => ({
		...state, // Forces editors to reload data into input.fields on cancel
	}))
);
